export const PREFIJO_HABITACION = "habitacion-";

export const ANCHO_DEFAULT = 90;
export const ALTO_DEFAULT = 70;

export const idNodoHabitacion = (habitacionId) => PREFIJO_HABITACION + habitacionId;
export const habitacionIdDeNodo = (idNodo) => idNodo.replace(PREFIJO_HABITACION, "");

//Arma los `nodes` de React Flow a partir de las habitaciones y de la ocupación que devolvió
//hoteleria/selectMapaHotel. Lo usan el visor (LienzoMapaHotel) y el editor (MapaHotelEditor), para que
//una habitación se vea exactamente igual en las dos pantallas.
//
//La clasificación de estado la calcula el backend (ver hoteleria.controllers.js/
//obtenerEstanciasPorHabitacion); aquí solo se decide el caso local "sin tarifa", que depende del
//catálogo y no de las ventas.
export const construirNodosHabitaciones = ({
  habitaciones = [],
  ocupacion = [],
  ocupacionProgramada = [],
  editable = false,
  onResize,
}) => {
  const ocupacionPorHabitacion = new Map(
    (ocupacion || []).map((valor) => [String(valor.habitacionId), valor])
  );
  const programadaPorHabitacion = new Map(
    (ocupacionProgramada || []).map((valor) => [String(valor.habitacionId), valor])
  );

  return habitaciones.map((valorHabitacion) => {
    const clave = String(valorHabitacion._id);
    const datosOcupacionReal = ocupacionPorHabitacion.get(clave);
    // Una reserva que "sale" ese día deja el cuarto disponible esa noche, así que no lo pinta: igual
    // que una venta real que sale hoy, pero sin color propio porque una salida proyectada no es un
    // evento que recepción tenga que atender.
    const datosProgramada =
      !datosOcupacionReal && programadaPorHabitacion.get(clave)?.estado === "programada"
        ? programadaPorHabitacion.get(clave)
        : undefined;

    // Precedencia: la venta real manda sobre la programada, y las dos sobre "sin tarifa". Si a una
    // habitación vendida le quitaron el insumo, sigue habiendo alguien dentro y pintarla de gris
    // sería mentir sobre lo que importa.
    const datosOcupacion = datosOcupacionReal || datosProgramada;
    const estadoOcupacion = datosOcupacion
      ? datosOcupacion.estado
      : valorHabitacion.insumoId
      ? "libre"
      : "sinTarifa";

    const ancho = valorHabitacion.ancho || ANCHO_DEFAULT;
    const alto = valorHabitacion.alto || ALTO_DEFAULT;

    return {
      id: idNodoHabitacion(valorHabitacion._id),
      type: "habitacion",
      position: { x: valorHabitacion.x || 0, y: valorHabitacion.y || 0 },
      style: { width: ancho, height: alto },
      draggable: editable,
      selectable: editable,
      connectable: false,
      data: {
        ...valorHabitacion,
        anchoActual: ancho,
        altoActual: alto,
        editable,
        estadoOcupacion,
        programada: !!datosProgramada,
        entraHoy: datosOcupacion ? !!datosOcupacion.entraHoy : false,
        sobreventa: datosOcupacion ? !!datosOcupacion.sobreventa : false,
        // La estancia que se muestra en la cajita es la que manda el color: la que sigue viva esta
        // noche si hay alguna, y si no, la que se va hoy.
        estancia: datosOcupacion
          ? (datosOcupacion.estancias || []).find((valor) => !valor.saleHoy) ||
            (datosOcupacion.estancias || [])[0] ||
            null
          : null,
        onResize: editable && onResize ? (params) => onResize(clave, params) : undefined,
      },
    };
  });
};
